import { buildStrapiUrl } from '../utils/strapi-url';
import { assertUpstreamOk, upstreamNotFound } from './assert-upstream';
import { fetchWithRetry } from './fetch-with-retry';

/**
 * Deliberately degrades to `[]` on failure: this feeds the client-rendered
 * TeamCards section, which is auxiliary content — a transient CMS error
 * should render an empty section, not break the page.
 */
export async function fetchAllTeams() {
  let data;
  try {
    const res = await fetchWithRetry(buildStrapiUrl('/api/web/teams'));
    assertUpstreamOk(res, 'Fetch teams');
    data = await res.json();
  } catch (error) {
    console.error('Error fetching teams:', error);
    return [];
  }

  return (data.data || []).sort((a: any, b: any) => {
    const orderA = a.order;
    const orderB = b.order;

    if (typeof orderA === 'number' && typeof orderB === 'number') {
      return orderA - orderB;
    }
    if (typeof orderA === 'number') return -1;
    if (typeof orderB === 'number') return 1;

    return a.name?.localeCompare(b.name);
  });
}

export async function fetchTeamBySlugOrNumber(slugOrNumber: string) {
  const res = await fetchWithRetry(
    buildStrapiUrl(`/api/web/teams/${encodeURIComponent(slugOrNumber)}`),
  );

  // Only an explicit 404 or empty result means the person does not exist.
  // A transient CMS error must throw — otherwise the profile page would cache
  // a "no longer works here" card for a real employee for the ISR window.
  if (upstreamNotFound(res)) {
    return null;
  }
  assertUpstreamOk(res, `Fetch team member "${slugOrNumber}"`);

  const data = await res.json();
  return data.data.length > 0 ? data.data[0] : null;
}
